import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../../components/Loading';

const LoginRedirect = () => {
  const { demoEpicOrgId, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    if (demoEpicOrgId) {
      window.location.href = `/${demoEpicOrgId}/login`;
    } else {
      window.location.href = '/error';
    }
  }, [demoEpicOrgId, isLoading]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-md w-full space-y-6 text-center">
        <Loading message="Redirecting to login..." />
      </div>
    </div>
  );
};

export default LoginRedirect;
